import React from 'react'

const SvgMegaphoneFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M8.001 18.5A1.5 1.5 0 115 18.5V15l-.997.002a2 2 0 01-2.001-2v-4a2 2 0 012-2h3c.335 0 .669-.018 1-.052L8.001 18.5zM17.797 14.795a1 1 0 011.414 0l1.5 1.5a1 1 0 01-1.414 1.414l-1.5-1.5a1 1 0 010-1.414zM13.712 4.53c.979-.653 2.29.049 2.29 1.225v10.507c0 1.171-1.306 1.87-2.28 1.22l-2.055-1.37a6.567 6.567 0 00-1.665-.798V6.535c.88-.28 1.721-.68 2.497-1.197l1.213-.809zM21.004 10.002a1 1 0 110 2h-2a1 1 0 010-2h2zM19.297 4.295a1 1 0 111.414 1.414l-1.5 1.5a1 1 0 01-1.414-1.414l1.5-1.5z' />
  </svg>
)

export default SvgMegaphoneFilled
